"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconEnum = void 0;
var IconEnum;
(function (IconEnum) {
    // FA Regular
    IconEnum["BOOK"] = "BOOK";
    IconEnum["CALENDAR"] = "CALENDAR";
    IconEnum["CALENDAR_DAY"] = "CALENDAR_DAY";
    IconEnum["CALENDAR_DAYS"] = "CALENDAR_DAYS";
    IconEnum["CALENDAR_PLUS"] = "CALENDAR_PLUS";
    IconEnum["CALENDAR_STAR"] = "CALENDAR_STAR";
    IconEnum["CIRCLE_QUESTION"] = "CIRCLE_QUESTION";
    IconEnum["CLOCK"] = "CLOCK";
    IconEnum["OUTLINED_OPEN_BOOK"] = "OUTLINED_OPEN_BOOK";
    IconEnum["STAR"] = "STAR";
    IconEnum["NOTEBOOK"] = "NOTEBOOK";
    // FA Solid
    IconEnum["BOOK_OPEN"] = "BOOK_OPEN";
    IconEnum["CARET_DOWN"] = "CARET_DOWN";
    IconEnum["INFO_CIRCLE"] = "INFO_CIRCLE";
    IconEnum["INFO"] = "INFO";
    IconEnum["PLUS"] = "PLUS";
    IconEnum["X_MARK"] = "X_MARK";
    IconEnum["CHECK"] = "CHECK";
    IconEnum["MENU"] = "MENU";
    IconEnum["EYE"] = "EYE";
    IconEnum["EYE_SLASH"] = "EYE_SLASH";
    IconEnum["WRENCH"] = "WRENCH";
    IconEnum["CHEVRON_DOWN"] = "CHEVRON_DOWN";
    IconEnum["CHEVRON_UP"] = "CHEVRON_UP";
    IconEnum["CHEVRON_LEFT"] = "CHEVRON_LEFT";
    IconEnum["CHEVRON_RIGHT"] = "CHEVRON_RIGHT";
    IconEnum["BARS_FILTER"] = "BARS_FILTER";
    IconEnum["ELLIPSIS"] = "ELLIPSIS";
    IconEnum["CLOCK_ROTATE_LEFT"] = "CLOCK_ROTATE_LEFT";
    // FA Brand
    IconEnum["BITBUCKET"] = "BITBUCKET";
    // Subjects
    IconEnum["BIBLE"] = "BIBLE";
    IconEnum["GEOGRAPHY"] = "GEOGRAPHY";
    IconEnum["LANGUAGE_ARTS"] = "LANGUAGE_ARTS";
    IconEnum["MATH"] = "MATH";
    IconEnum["SCIENCE"] = "SCIENCE";
    IconEnum["ELECTIVE"] = "ELECTIVE";
    // Assignment Status
    IconEnum["PROJECT"] = "PROJECT";
    IconEnum["OVERDUE"] = "OVERDUE";
    IconEnum["STARTED_ASSIGNMENT"] = "STARTED_ASSIGNMENT";
    IconEnum["LOCK"] = "LOCK";
    // Navigational
    IconEnum["COURSE_CATALOG"] = "COURSE_CATALOG";
    IconEnum["COURSE_CATALOG_FILLED"] = "COURSE_CATALOG_FILLED";
    IconEnum["GRADEBOOK"] = "GRADEBOOK";
    IconEnum["GRADEBOOK_FILLED"] = "GRADEBOOK_FILLED";
    IconEnum["HOME"] = "HOME";
    IconEnum["HOME_FILLED"] = "HOME_FILLED";
    IconEnum["PLANNER"] = "PLANNER";
    IconEnum["PLANNER_FILLED"] = "PLANNER_FILLED";
    // Planner
    IconEnum["RESCHEDULE"] = "RESCHEDULE";
    IconEnum["ADD_EVENT"] = "ADD_EVENT";
    IconEnum["TIME_OFF"] = "TIME_OFF";
    IconEnum["TODAY"] = "TODAY";
    IconEnum["LIGHT_PENCIL"] = "LIGHT_PENCIL";
    IconEnum["LIGHT_BOOKS"] = "LIGHT_BOOKS";
    IconEnum["TROPHY"] = "TROPHY";
    IconEnum["CAKE_CANDLES"] = "CAKE_CANDLES";
    IconEnum["BRIEFCASE_MEDICAL"] = "BRIEFCASE_MEDICAL";
    IconEnum["BUILDING_COLUMNS"] = "BUILDING_COLUMNS";
    IconEnum["VAN_SHUTTLE"] = "VAN_SHUTTLE";
    IconEnum["UMBRELLA_BEACH"] = "UMBRELLA_BEACH";
    IconEnum["FAMILY"] = "FAMILY";
    IconEnum["LEAF"] = "LEAF";
    IconEnum["PERSON_SWIMMING"] = "PERSON_SWIMMING";
    IconEnum["PERSON_RUNNING"] = "PERSON_RUNNING";
    IconEnum["FACE_THERMOMETER"] = "FACE_THERMOMETER";
    // Misc
    IconEnum["USER_GROUP_SOLID"] = "USER_GROUP_SOLID";
    IconEnum["LEFT_TO_LINE"] = "LEFT_TO_LINE";
    IconEnum["STAR_SHARP_SOLID"] = "STAR_SHARP_SOLID";
    IconEnum["SUN_SOLID"] = "SUN_SOLID";
    IconEnum["SNOWFLAKE_SOLID"] = "SNOWFLAKE_SOLID";
    IconEnum["PARTY_HORN_SOLID"] = "PARTY_HORN_SOLID";
    IconEnum["CALENDAR_MINUS_REGULAR"] = "CALENDAR_MINUS_REGULAR";
    IconEnum["GROUP"] = "GROUP";
    IconEnum["CIRCLE_PLAY"] = "CIRCLE_PLAY";
    IconEnum["CIRCLE_CHECK"] = "CIRCLE_CHECK";
    IconEnum["CIRCLE_X"] = "CIRCLE_X";
})(IconEnum || (exports.IconEnum = IconEnum = {}));
